export const USER_TYPE_FILTERS = {
  ALL: "all"
};
